import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-[#dadbd5] bg-white px-3 py-1 text-base text-[#1c2620] shadow-[0_1px_2px_rgba(28,38,32,0.04)] transition-[border-color,box-shadow] file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#1c2620] placeholder:text-[#a8aea3] hover:border-[#c5c8bf] focus-visible:outline-none focus-visible:border-[#2d6a4f] focus-visible:ring-[3px] focus-visible:ring-[#2d6a4f]/15 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
